import { Injectable } from "@angular/core";

declare global {
  interface Window {
    watsonAssistantChatOptions?: any;
  }
}

@Injectable({
  providedIn: "root",
})

export class ChatbotService {
    loadChatbot(userDetails) {
        console.log('ChatbotService', window.watsonAssistantChatOptions);
        if (!window.watsonAssistantChatOptions && userDetails && userDetails.beta) {
            setTimeout(function () {
                const t = document.createElement('script');
                t.src = "https://web-chat.global.assistant.watson.appdomain.cloud/versions/" + (window.watsonAssistantChatOptions.clientVersion || 'latest') + "/WatsonAssistantChatEntry.js";
                document.head.appendChild(t);
            });
            return window.watsonAssistantChatOptions = {
                integrationID: "473529ac-55f0-4b5c-b261-25614e5f82a3", // The ID of this integration.
                region: "wxo-us-south", // The region your integration is hosted in.
                serviceInstanceID: "1dc56737-0aa0-416e-9831-89d8cacf6818", // The ID of your service instance.
                onLoad: async (instance) => {
                        return instance.render();
                }
            };
        }
        const rootWebChat = document.querySelector(".WatsonAssistantChatHost") as HTMLElement;
        if (rootWebChat) {rootWebChat.style.display = "flex";}
        
    }

    HideChatbot() {
        const rootWebChat = document.querySelector(".WatsonAssistantChatHost") as HTMLElement;
        rootWebChat.style.display = "none";

    }

}